
import index from './'
import form from './form'

export default [
  {
    path: '/compras',
    name: 'compras.index',
    component: index,
    children: [
      {
        path: 'form/:id?',
        name: 'compras.form',
        component: form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/features/compras/compras/routes.js